import InmuebleTemplate from "../../components/templates/inmuebles/InmuebleTemplate"

const Inmueble = () => {
    return <InmuebleTemplate/>;
};

export default Inmueble;